import devStore from './configureStore.dev';
import productionStore from './configureStore.prod';

export default (...args) => {
  const store =
    process.env.NODE_ENV === 'production' ? productionStore : devStore;

  return store(...args);
};
